<template>
  <div>
    <div class="row">
      <div
        v-show="tokenError"
        class="alert alert-danger col-md-4 offset-md-4 col-xs-12"
      >Your password reset link is expired.</div>
    </div>
    <div
      v-show="success"
      class="alert alert-success col-md-4 offset-md-4 col-xs-12"
    >Your password has been changed successfully!</div>

    <div v-show="!tokenError && !success">
      <div class="row">
        <input
          type="password"
          placeholder="Enter New Password"
          v-model="password"
          class="form-control col-md-4 offset-md-4 col-xs-12 my-2 px-2"
        />
        <input
          type="password"
          placeholder="Enter New Password Again"
          v-model="confirm"
          class="form-control col-md-4 offset-md-4 col-xs-12 my-2 px-2"
        />
        <div class="col-md-4 offset-md-4 col-xs-12 my-2 px-2">
          <ul style="color:red;">
            <li v-for="error in errors">{{error}}</li>
          </ul>
        </div>
        <div class="col-md-4 offset-md-4 col-xs-12 my-2 px-2">
          <button class="btn btn-primary" v-on:click="submit">Submit</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../commons/http.js";
export default {
  data: function() {
    return {
      tokenError: false,
      password: "",
      confirm: "",
      errors: [],
      success:false
    };
  },
  methods: {
    verify: async function() {
      try {
        let response = await http.post("/verify", {
          token: this.$route.params.token
        });
      } catch (err) {
        this.tokenError = true;
      }
    },
    validate: function() {
      this.errors = [];
      if (this.password.length < 6) {
        this.errors.push("Password must be at least 6 characters");
      } else if (this.password !== this.confirm) {
        this.errors.push("Password confirmation does not match");
      }
      return this.errors.length;
    },
    submit: async function() {
      if (this.validate() > 0) {
        return;
      }

      let data = {
        password: this.password,
        token: this.$route.params.token
      };
      try{
        http.post("/reset/change", data);
        this.success = true;
      }catch(err){
        console.error('reset err', err);
      }
    }
  },
  beforeMount: function() {
    if (typeof this.$route.params.token === "undefined") {
      alert("Please use link sent to your email to perform password reset.");
      location.href = "#/";
    }

    this.verify();
  }
};
</script>

<style>
</style>
